module.exports = __webpack_public_path__ + "static/media/15UN-Habitat12.7accf045.jpg";